import { faBuilding, faKey, faLock, faUser } from '@fortawesome/free-solid-svg-icons';
import { USER_SETTINGS_CONSTANTS, USER_SETTINGS_GROUPS } from '@ids-constants';
import { ILayoutItem } from '@microsec/interfaces';
import { TokenManagementComponent } from './developer/token-management/token-management.component';
import { OrganizationsComponent } from './preferences/organizations/organizations.component';
import { AccountSecurityComponent } from './preferences/account-security/account-security.component';
import { PersonalInformationComponent } from './preferences/personal-information/personal-information.component';

export const USER_SETTINGS_CHILDREN: ILayoutItem[] = [
  {
    group: USER_SETTINGS_GROUPS.PREFERENCES,
    route: USER_SETTINGS_CONSTANTS.ORGANIZATIONS.ROUTE,
    icon: faBuilding,
    label: USER_SETTINGS_CONSTANTS.ORGANIZATIONS.LABEL,
    component: OrganizationsComponent,
  },
  {
    group: USER_SETTINGS_GROUPS.PREFERENCES,
    route: USER_SETTINGS_CONSTANTS.ACCOUNT_SECURITY.ROUTE,
    icon: faLock,
    label: USER_SETTINGS_CONSTANTS.ACCOUNT_SECURITY.LABEL,
    component: AccountSecurityComponent,
  },
  {
    group: USER_SETTINGS_GROUPS.PREFERENCES,
    route: USER_SETTINGS_CONSTANTS.PERSONAL_INFORMATION.ROUTE,
    icon: faUser,
    label: USER_SETTINGS_CONSTANTS.PERSONAL_INFORMATION.LABEL,
    component: PersonalInformationComponent,
  },
  {
    isSeparator: true,
  },
  {
    group: USER_SETTINGS_GROUPS.DEVELOPER,
    route: USER_SETTINGS_CONSTANTS.TOKEN_MANAGEMENT.ROUTE,
    icon: faKey,
    label: USER_SETTINGS_CONSTANTS.TOKEN_MANAGEMENT.LABEL,
    component: TokenManagementComponent,
  },
];
